import React, { useEffect, useState } from "react";
import { Skeleton } from "primereact/skeleton";
import { Link, Navigate, useOutletContext } from "react-router-dom";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import {
  getListeForfaits_allRight,
  getListeForfaits_secure,
} from "../../../services/forfait/ForfaitRequest";
import { getAbonneInfo_allRight } from "../../../services/abonne/AbonneRequest";
import { isAuthenticated } from "../../../utils/AuthGuard";

const AcheterForfait = () => {
  const [customerPhoneNumber, customerPasswordStat] = useOutletContext();
  const [user, setUser] = useState(null);
  const [loadingListeForfait, setLoadingListeForfait] = useState(true);
  const [listeForfaits, setListeForfaits] = useState([]);
  const [serviceListe, setServiceListe] = useState([
    {
      id: 0,
      volume: "25",
      unite: "GO",
      designation: "SIM & device",
      cout: "25000",
    },
    {
      id: 1,
      volume: "50",
      unite: "GO",
      designation: "SIM & device",
      cout: "25000",
    },
    {
      id: 2,
      volume: "150",
      unite: "GO",
      designation: "SIM & device",
      cout: "25000",
    },
    {
      id: 3,
      volume: "200",
      unite: "GO",
      designation: "SIM & device",
      cout: "25000",
    },
    {
      id: 4,
      volume: "500",
      unite: "GO",
      designation: "SIM & device",
      cout: "25000",
    },
  ]);

  useEffect(() => {
    try {
      sessionStorage.removeItem("userPhoneNumber");
      if (sessionStorage.getItem("customer_number")) {
        setLoadingListeForfait(true);
      }
      getAbonneInfo_allRight(customerPhoneNumber)
        .then((res) => {
          setUser(res.data.donnee);
          if (sessionStorage.getItem("token")) {
            if (sessionStorage.getItem("customer_number")) {
              setLoadingListeForfait(true);
              getListeForfaits_secure("ACHETER_FORFAIT", customerPhoneNumber)
                .then((res) => {
                  setLoadingListeForfait(false);
                  setListeForfaits(res.data.donnee);
                })
                .catch((err) => {
                  setLoadingListeForfait(false);
                  console.log("api error", err);
                });
            } else {
              getListeForfaits_secure("ACHETER_FORFAIT", "")
                .then((res) => {
                  setLoadingListeForfait(false);
                  setListeForfaits(res.data.donnee);
                })
                .catch((err) => {
                  setLoadingListeForfait(false);
                  console.log("api error", err);
                });
            }
          } else {
            if (sessionStorage.getItem("customer_number")) {
              setLoadingListeForfait(true);
              getListeForfaits_allRight("ACHETER_FORFAIT", customerPhoneNumber)
                .then((res) => {
                  setLoadingListeForfait(false);
                  setListeForfaits(res.data.donnee);
                })
                .catch((err) => {
                  setLoadingListeForfait(false);
                  console.log("api error", err);
                });
            } else {
              getListeForfaits_allRight("ACHETER_FORFAIT", "")
                .then((res) => {
                  setLoadingListeForfait(false);
                  setListeForfaits(res.data.donnee);
                })
                .catch((err) => {
                  setLoadingListeForfait(false);
                  console.log("api error", err);
                });
            }
          }
        })
        .catch((err) => {
          setLoadingListeForfait(false);
          console.log("api error", err);
        });
    } catch (error) {
      setLoadingListeForfait(false);
      console.log("catch error", error);
    }
  }, [sessionStorage.getItem("token"), customerPhoneNumber, customerPasswordStat]);

  return (
    <div>
      <div className="w-11/12 xl:w-10/12 mx-auto sm:grid grid-cols-2 justify-items-center lg:grid-cols-3 gap-y-8 sm:gap-x-4">
        <div className="sm:w-[19rem] md:w-80 py-2 bg-black rounded-tl-md rounded-br-md px-4">
          <h2 className="text-white text-sm sm:text-base">
            Acheter un forfait :
          </h2>
        </div>
      </div>
      {/* PRODUCTS FOR DESKTOP */}
      <div className="w-11/12 xl:w-10/12 mx-auto hidden sm:grid grid-cols-2 justify-items-center lg:grid-cols-3 gap-y-8 sm:gap-x-4 mt-10 pb-16">
        {listeForfaits.length > 0 && !loadingListeForfait ? (
          listeForfaits.map((item, index) => (
            <Link
              to={`/detail-forfait/${item.id}`}
              className="block"
              key={index}
              onClick={() =>
                sessionStorage.setItem("typeAchat", "ACHAT_POUR_SOI")
              }
            >
              <div className="w-[19rem] md:w-80 bg-gray-100 border-4 border-white rounded-2xl w-fit h-20 flex items-center shadow-xl">
                <div className="w-1/3 px-3 h-full rounded-tl-xl rounded-bl-xl flex flex-col items-center justify-center bg-jaune-mtn">
                  {item.volume ? (
                    <p className="text-black text-xl font-bold">
                      {item.volume} {item.unite}
                    </p>
                  ) : (
                    <p className="text-black text-xl font-bold">Illimité</p>
                  )}
                </div>
                <div className="w-2/3 h-full rounded-2xl flex items-center justify-between gap-x-6 bg-transparent p-3">
                  <div>
                    <p className="text-black text-center flex flex-col items-center text-xl font-bold leading-5">
                      {item.cout}
                      <span className="text-sm">FCFA</span>
                    </p>
                  </div>
                  <div className="bg-jaune-mtn w-10 h-10 rounded-full flex items-center justify-center ml-4 cursor-pointer">
                    <KeyboardArrowRightIcon />
                  </div>
                </div>
              </div>
            </Link>
          ))
        ) : listeForfaits.length === 0 && loadingListeForfait ? (
          <>
            <Skeleton height="6rem" borderRadius="1rem"></Skeleton>
            <Skeleton height="6rem" borderRadius="1rem"></Skeleton>
            <Skeleton height="6rem" borderRadius="1rem"></Skeleton>
            <Skeleton height="6rem" borderRadius="1rem"></Skeleton>
            <Skeleton height="6rem" borderRadius="1rem"></Skeleton>
          </>
        ) : listeForfaits.length === 0 && !loadingListeForfait ? (
          <div className="flex items-center justify-center">
            <p className="text-center text-xl text-red-500">
              Aucun forfait trouvé
            </p>
          </div>
        ) : null}
      </div>

      {/* PRODUCTS FOR MOBILE */}
      <div className="liste-forfait-mobile list-forfait w-11/12 mx-auto mt-10 sm:hidden grid grid-cols-2 gap-y-8 gap-x-4 pb-16 justify-items-center">
        {listeForfaits.length > 0 && !loadingListeForfait ? (
          listeForfaits.map((item, index) => (
            <Link
              to={`/detail-forfait/${item.id}`}
              key={index}
              onClick={() =>
                sessionStorage.setItem("typeAchat", "ACHAT_POUR_SOI")
              }
              className="w-full"
            >
              <div className="forfait-mobile w-full rounded-xl shadow-lg border-4 border-white bg-gray-mtn">
                <div className="bg-jaune-mtn rounded-tl-xl rounded-tr-xl py-3">
                  {item.volume ? (
                    <p className="volume-forfait text-black text-2xl text-center font-bold">
                      {item.volume} {item.unite}
                    </p>
                  ) : (
                    <p className="volume-forfait text-black text-2xl text-center font-bold">
                      Illimité
                    </p>
                  )}
                </div>
                <div className="bg-transparent rounded-tl-xl rounded-tr-xl flex items-center justify-evenly py-3">
                  <div>
                    <p className="prix-forfait text-black text-lg text-center font-bold leading-4">
                      {item.cout} <br />
                      <span className="text-xs">FCFA</span>
                    </p>
                  </div>

                  <div className="bg-jaune-mtn w-7 h-7 rounded-full flex items-center justify-center ml-4 cursor-pointer">
                    <KeyboardArrowRightIcon />
                  </div>
                </div>
              </div>
            </Link>
          ))
        ) : listeForfaits.length === 0 && loadingListeForfait ? (
          <>
            <Skeleton height="5rem" borderRadius="1rem"></Skeleton>
            <Skeleton height="5rem" borderRadius="1rem"></Skeleton>
            <Skeleton height="5rem" borderRadius="1rem"></Skeleton>
            <Skeleton height="5rem" borderRadius="1rem"></Skeleton>
            <Skeleton height="5rem" borderRadius="1rem"></Skeleton>
          </>
        ) : listeForfaits.length === 0 && !loadingListeForfait ? (
          <div className="flex items-center justify-center">
            <p className="text-center text-xl text-red-500">
              Aucun forfait trouvé
            </p>
          </div>
        ) : null}
      </div>

      <div className="w-11/12 xl:w-9/12 mx-auto mt-10 pb-16">
        <div className="sm:w-[19rem] md:w-80 py-2 bg-black rounded-tl-md rounded-br-md px-4">
          <h2 className="text-white text-sm sm:text-base">Votre compte :</h2>
        </div>
        <div className="w-full h-fit mt-10 px-4 md:px-8 py-5 rounded-tl-3xl rounded-br-3xl bg-white border-2 border-black">
          <div className="account-detail">
            <div className="detail-item flex items-start">
              <p className="text-sm sm:text-base md:text-lg pb-3 w-2/4 lg:w-1/3">
                Numéro :
              </p>
              <p className="text-sm sm:text-base md:text-lg font-bold w-2/4 pb-1">
                {user ? user.numero : "..."}
              </p>
            </div>
            <div className="detail-item flex items-start">
              <p className="text-sm sm:text-base md:text-lg pb-3 w-2/4 lg:w-1/3">
                Crédit de communication :
              </p>
              <p className="text-sm sm:text-base md:text-lg font-bold w-2/4 pb-1">
                {user ? user.Solde : "..."} FCFA
              </p>
            </div>
            <div className="detail-item flex items-start">
              <p className="text-sm sm:text-base md:text-lg pb-3 w-2/4 lg:w-1/3">
                Volume internet disponible :
              </p>
              {user && user.forfaits.length !== 0 ? (
                <div>
                  {user.forfaits.map((item, index) => (
                    <p
                      className="text-sm sm:text-base md:text-lg font-bold pb-1"
                      key={index}
                    >
                      {item.data} Mo <span>valable(s) jusqu'au</span>{" "}
                      {item.validite}
                    </p>
                  ))}
                </div>
              ) : (
                "Vous ne disposez pas de forfait actif"
              )}
            </div>
            {/* <div className="detail-item flex items-start">
              <p className="text-sm sm:text-base md:text-lg pb-3 w-2/4 lg:w-1/3">
                Service(s) MTN Play actif(s) :
              </p>
              <p className="text-sm sm:text-base md:text-lg font-bold w-2/4 pb-1">
                XXXXXX
              </p>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AcheterForfait;
